export default {
    url: '/confirm?token',
    cache: false,
    template: '<auth-confirm token="vm.token"></auth-confirm>',
    controller ($stateParams) {
        this.token = $stateParams.token;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/unauthorized/confirm/index.js